import { useCallback } from "react"
import { useParams } from "react-router-dom"
import { useSetState, usePrevious } from "ahooks-v2"
import type { RouterIdsVO } from "@/api"
// ==============================================
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface CustomParamsArgs {}
function useCustomParams() {
  const { cityId, brandId } = useParams<RouterIdsVO>() as any
  const prevCityId = usePrevious(cityId) || cityId
  const prevBrandId = usePrevious(brandId) || brandId
  const [state, set] = useSetState<CustomParamsArgs>()

  // 城市或品牌是否改变
  const isCityBrandChange = useCallback(() => {
    if (cityId !== prevCityId || brandId !== prevBrandId) {
      return true
    }
    return false
  }, [cityId, prevCityId, brandId, prevBrandId])

  const setAllState = useCallback(
    (
      value:
        | Partial<CustomParamsArgs>
        | ((prevState: CustomParamsArgs) => Partial<CustomParamsArgs>),
    ) => {
      set(value)
    },
    [set],
  )

  return {
    ...state,
    setAllState,
    isCityBrandChange,
  }
}

export default useCustomParams
